// @flow
import React, {Fragment} from "react";

import ReactDOM from "react-dom";
import Helmet from 'react-helmet';
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import {unregister} from "./registerServiceWorker";
import App from "./Components/App";
import store from "./Store/Store";
import {Provider} from "react-redux";
import {
    BrowserRouter as Router,
    Route,
} from "react-router-dom";
import {getAllQueryParams} from "./Utils/AppUtils";
import "./Utils/Polyfills";
import { strings, images } from "./config";

// if (process.env.NODE_ENV !== "production" ) {
//     const {whyDidYouUpdate} = require("why-did-you-update");
//     whyDidYouUpdate(React);
// }
//todo(Oded): tests

ReactDOM.render(
    <Provider store={store}>
        <Fragment>
            <Helmet>
                <title>{strings.title}</title>
                <link rel="icon" href={images.favicon} />
            </Helmet>
            <Router>
                <Route exact path="/rider/app/"
                       render={(props) => <App {...props} token={getAllQueryParams().token}/>}/>
                {/*TODO(Oded): add a 404 page bad routes?*/}
                {/*TODO(Oded): add a 403 page for no token?*/}
            </Router>
        </Fragment>
    </Provider>,
    window.document.getElementById("root"));

// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js